var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discount-badge d-inline-flex flex-wrap align-items-center justify-content-center"},[(_vm.showsLabel)?_c('div',{staticClass:"w-100 text-center"},[_vm._v("bis zu")]):_vm._e(),_c('span',{staticClass:"percentage"},[_vm._v(_vm._s(_vm.formatValue(_vm.value)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }